<template>
    <div class="kts-filter__top box-filter-wrapper">
      <div class="box-cat-filter splide">
        <div class="splide__track">
          <div class="list-cat splide__list">
            <div class="cart-item splide__slide inactive">
                <label :for="'cat-product_cat_all'">
                <input
                  id="cat-product_cat_all"
                  type="checkbox"
                  name="product_cat[]"
                  value="all"
                  v-model="checkedAll"
                  @change="selectItemFilter('all', false)"
                />
                <span> All</span>
              </label>
            </div>

            <div
                v-if="menuFilterItems"
                v-for="(item, index) in menuFilterItems.subMenu"
                :key="index"
                class="cart-item splide__slide inactive"
                :class="'term_' + index"
              >
                <label :for="'cat-product_cat_' + index">
                  <input
                    :id="'cat-product_cat_' + index"
                    class="cart-item-checkbox"
                    type="checkbox"
                    name="product_cat[]"
                    :value="index"
                    v-model="item.isActive"
                    @change="selectItemFilter(item.slug, item.isActive)"
                  />
                  <span v-html="item.name"></span>
                </label>
              </div>
          </div>
        </div>
        <div class="my-slider-progress" :class="{ 'is-active': isSliderActive }">
          <div class="my-slider-progress-bar" :style="{ width: progressBarWidth + '%' }"></div>
        </div>
      </div>
    </div>
  </template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import Splide from "@splidejs/splide";
import type { IProductFilterData, RelevantData, MenuCategory } from '~/types/product-filter';

interface Props {
  menuFilter: MenuCategory;
}

const props = defineProps<Props>();

  // const props = defineProps({
  // isActive: Boolean,
  //   menuFilter: {
  //     type: Object,
  //     required: true
  //   }
  // });
  const emit = defineEmits(["triggerQueryFilter"]);

  // Local copy of the checked items
  // const localCheckedItems = ref([...props.checkedItems]);

  // Watch for updates to checkedItems
  // watch(
  //   () => props.checkedItems,
  //   (newVal) => {
  //     localCheckedItems.value = [...newVal];
  //   }
  // );

//   watch(
//   () => menuItems.value,
//   (afterFilter) => {
//     console.log('afterFilter', afterFilter);
//     //emit("updateAfterFilter", afterFilter);
//   },
//   { deep: true,immediate: true }
// );

  // Reactive state
const checkedAll = ref(false);
const isSliderActive = ref(false);
const progressBarWidth = ref(0);
const menuFilterItems = ref<MenuCategory>(props.menuFilter);

const selectItemFilter = (slug: string, active: boolean) => {
  Object.values(menuFilterItems.value.subMenu).forEach(sub => {
    if (sub.slug !== slug) {
      sub.isActive = false;
    }
  });

  if (slug !== "all") {
    checkedAll.value = false;
  }

  emit("triggerQueryFilter", slug, active);
}



const initializeSlider = () => {
  setTimeout(() => {
    const sliderElement = document.querySelector(".box-cat-filter");
    if (!sliderElement) return;

    const splide = new Splide(sliderElement, {
      arrows: false,
      pagination: false,
      drag: "free",
      mediaQuery: "max",
      autoWidth: true,
    });

    splide.on("mounted move drag", () => {
      const end = splide.Components.Controller.getEnd() + 1;
      const current = splide.index + 1;
      progressBarWidth.value = Math.min(100, Math.max(0, (current / end) * 100));
    });

    splide.mount();
    isSliderActive.value = true;
  }, 100); // Delay of 100ms before initializing the slider
}

watch(
  () => menuFilterItems.value.subMenu,
  (newSubMenu) => {
    if (newSubMenu && Object.keys(newSubMenu).length > 0) {
      initializeSlider(); // Only initialize the slider when subMenu has data
    }
  },
  { immediate: true } // This ensures it runs once immediately when data is first populated
);

watch(() => props.menuFilter, () => {
  menuFilterItems.value = props.menuFilter;
})

</script>

<style lang="scss" scoped>
 @import '@/assets/scss/components/sale-campaign/_filter.scss';
</style>
